import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import {
    Box,
    Link,
    Typography,
} from "@mui/material"
import BadgeAvatar from "../../features/mockups/BadgeAvatar"

export type MemberIdentityProps = {
    name?: string | null
    userName?: string | null
    userId?: string | null
    email?: string | null
    position?: string | null
    companyName?: string | null
    size?: "small" | "medium"
    avatarColor?: string
    avatarBackgroundColor?: string
    showContact?: boolean
}

const sizeConfig = {
    small: {
        avatar: 32,
        fontSize: 12,
        gap: 1,
    },
    medium: {
        avatar: 36,
        fontSize: 13,
        gap: 1.25,
    },
} as const


export const MemberIdentity = ({
    name,
    userName,
    userId,
    email,
    position,
    companyName,
    size = "medium",
    avatarColor,
    avatarBackgroundColor,
    showContact = true,
}: MemberIdentityProps) => {
    const config = sizeConfig[size]
    const displayName = name || userName || email || "Nieznany uzytkownik"
    const contactLabel = userName || email
    const contactEmail = email
        || (userName?.includes("@") ? userName : null)

    const contactContent = contactLabel && <>
        <EmailOutlinedIcon
            sx={{
                fontSize: 13,
                flexShrink: 0,
            }}
        />
        <Typography
            variant="caption"
            noWrap
            sx={{
                fontSize: "0.72rem",
                lineHeight: 1.3,
            }}
        >
            {contactLabel}
        </Typography>
    </>

    const [firstName = "", surname = ""] = displayName.trim().split(/\s+/, 2)



    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: config.gap,
                minWidth: 0,
            }}
        >
            <BadgeAvatar
                firstName={firstName}
                surname={surname}
                userId={userId ?? ""}
            />

            <Box sx={{ minWidth: 0 }}>
                <Typography
                    variant="body2"
                    sx={{ fontWeight: 600 }}
                    noWrap
                >
                    {displayName}
                </Typography>

                {[position, companyName]
                    .filter((value): value is string => Boolean(value))
                    .map((value, index) => (
                        <Typography
                            key={`${value}-${index}`}
                            variant="caption"
                            color="text.secondary"
                            noWrap
                            sx={{
                                display: "block",
                                lineHeight: 1.35,
                            }}
                        >
                            {value}
                        </Typography>
                    ))}

                {showContact && contactContent && (
                    contactEmail
                        ? <Link
                            href={`mailto:${contactEmail}`}
                            underline="none"
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.4,
                                color: "text.disabled",
                                maxWidth: "100%",
                                mt: 0.2,
                            }}
                        >
                            {contactContent}
                        </Link>
                        : <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.4,
                                color: "text.disabled",
                                maxWidth: "100%",
                                mt: 0.2,
                            }}
                        >
                            {contactContent}
                        </Box>
                )}
            </Box>
        </Box>
    )
}